import { Navigate } from "react-router-dom";
import ContractWithdrawalForm from "../../ContractWithdrawal/New/ContractWithdrawalForm";
import { GenericWrapperWithNavigateAndBackUrl } from "../genericWrappers";
import NoRouteErrorPage from "../no-route-error-page";

const contractWithdrawalRoutes = [
  {
    path: "ContractWithdrawal",
    children: [
      {
        index: true,
        element: <Navigate to="new" replace />,
      },
      {
        path: "new",
        element: (
          <GenericWrapperWithNavigateAndBackUrl
            key={"ContractWithdrawal/new"}
            component={ContractWithdrawalForm}
          />
        ),
      },
      {
        path: "*",
        element: <NoRouteErrorPage />,
      },
    ],
  },
];

export default contractWithdrawalRoutes;
